export default __webpack_public_path__ + "static/lukasz-5dba46cc82650e23e05cf8a8a83056fa.jpg";